import { defineStore } from 'pinia'

export const anfragenStore = defineStore('AnfrageStore', {
  state: () => ({
    items: [],
  }),
  getters: {
    getItems: (state) => state.items,
  },
  actions: {
    addItem(item) {
      const counter = this.items.length + 1;
      item.ID = counter;
      this.items.push(item);
    },
    delItem(item) {
      const index = this.items.findIndex((i) => i.ID === item.ID);
      if (index !== -1) {
        this.items.splice(index, 1);
      }
    },
    clearItems() {
      this.items = [];
    },
  },
});
